<template>
  <div class="group">
    <v-card v-if="group" max-width="500" class="mx-auto">
      <v-card-actions>
        <v-btn text color="blue-grey" @click="goToGroups">
            <v-icon>mdi-arrow-left</v-icon>
            <span class="ml-2">돌아가기</span>
        </v-btn>
      </v-card-actions>
      <v-img
        v-if="!userExisting"
        class="white--text"
        height="300px"
        :src="group.imgURL"
      >
        <v-card-title class="align-end fill-height">{{ group.name }}</v-card-title>
      </v-img>
      <v-img
        v-if="userExisting"
        height="630px"
        src="/autumnal-leaves.jpg"
      >
        <v-card-title class="align-end fill-height">{{ group.name }}</v-card-title>
    </v-img>
    <v-card-text v-if="!userExisting">
        <v-list two-line subheader>
          <v-subheader>모임 정보</v-subheader>
          <v-list-item>
            <v-list-item-action></v-list-item-action>
            <v-list-item-content>
              <v-list-item-title v-text="group.region"></v-list-item-title>
              <v-list-item-subtitle>지역</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-icon>
              <v-icon>mdi-map-marker</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-divider inset></v-divider>
          <v-list-item>
            <v-list-item-action></v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ group.members.length }}</v-list-item-title>
              <v-list-item-subtitle>회원수</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-icon>
              <v-icon>mdi-account-group</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-divider inset></v-divider>
          <v-list-item>
            <v-list-item-action></v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ group.creator.name }}</v-list-item-title>
              <v-list-item-subtitle>방장</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-avatar>
              <v-img :src="group.imgURL"></v-img>
            </v-list-item-avatar>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <!-- component -->
        <JoinUs v-if="!userExisting" :user="user" :group="group" :groupId="groupId" />
        
        <!-- go to Game -->
        <v-btn v-if="userExisting" text color="blue-grey" router :to="{ name: 'Games', params: {group_id: groupId} }">
          <span class="ml-2">게임으로 가기</span>
          <v-icon>mdi-arrow-right</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import db from '@/fb'
import firebase from 'firebase/app'
import 'firebase/auth'
import JoinUs from '@/components/JoinUs'

export default {
  name: 'Group',
  components: { JoinUs },
  data: () => ({
    group: '',
    groupId: '',
    user: '',
    userExisting: false
  }),
  methods: {
    goToGroups(){
      this.$router.push({ name: 'Groups' })
    }
  },
  created(){

    // create user
    let user = firebase.auth().currentUser;
    if(user){
        // find the user record
        db.collection('users').where('user_id', '==', user.uid).get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    this.user = {
                      ...doc.data(),
                      id: doc.id
                    };
                })
            })
    } else {
        return false
    }

    // get the group
    this.groupId = this.$route.params.group_id;
    db.collection('groups').doc(this.groupId).get().then(doc => {
      this.group = doc.data();
    }).then(() => {
      // find the user among the members of the group
      this.group.members.forEach(member => {
        if(member.alias == this.user.alias ){
          this.userExisting = true;
        } else {
          return false
        }
      });
    })
  }

};
</script>

<style>

a {
    text-decoration: none;
}

</style>